/** Base Selector API — profiles (Compass-native) + live contract quotes. */
import { apiGet, apiPost, apiDelete } from './client'

export interface BSContract {
  id?: number
  osi_symbol: string
  underlying: string
  /** CASH = short-put collateral; derived on the page, never saved. */
  sec_type: 'STK' | 'OPT' | 'CASH'
  strike: number | null
  expiry: string | null // YYYYMMDD
  right: 'C' | 'P' | null
  /** PROTECT = a long put bought as a floor, scored apart from the base. */
  position: 'BASE' | 'SHORT' | 'PROTECT'
  group_name: string | null
  quantity: number
  display_order: number
  /** Local what-if state; disabled legs stay visible but do not enter calculations. */
  disabled?: boolean
}

export interface BSProfile {
  id: number
  name: string
  updated_at: string | null
  contracts: BSContract[]
}

export interface BSQuoteRow {
  underlying: string
  sec_type: string
  strike?: number | null
  expiry?: string | null
  right?: string | null
  conid: number | null
  bid: number | null
  ask: number | null
  last: number | null
  mark: number | null
  delta: number | null
  iv: number | null
  und_price: number | null
  intrinsic: number | null
  extrinsic: number | null
}

export const getBSProfiles = () =>
  apiGet<{ profiles: BSProfile[] }>('/base-selector/profiles')

export const saveBSProfile = (name: string, contracts: BSContract[]) =>
  apiPost<{ id: number; name: string }>('/base-selector/profiles', { name, contracts })

export const deleteBSProfile = (profileId: number) =>
  apiDelete<{ ok: boolean }>(`/base-selector/profiles/${profileId}`)

export const getBSQuotes = (contracts: Array<Partial<BSContract>>) =>
  apiPost<{ rows: BSQuoteRow[] }>('/base-selector/quotes', { contracts }, { timeout: 45_000 })
